import { API } from "../core/config";
import client from "../core/http/client";
import { MeApiResponse, RefreshData, StatusData, UserMe } from "../models/auth";
import { ApiResponse } from "../shared/types/api";

/**
 * Config custom : bypass le refresh automatique sur les routes
 * où un 401 est NORMAL (login raté, refresh expiré, logout, etc.)
 */
const SKIP_REFRESH_CONFIG = {
  _skipAuthRefresh: true,
} as const;

class AuthApi {
  /**
   * API Status
   */
  async status(): Promise<ApiResponse<StatusData>> {
    const response = await client.get<ApiResponse<StatusData>>(
      API.AUTH.STATUS,
    );

    return response.data;
  }

  /**
   * Refresh Session
   */
  async refresh(): Promise<ApiResponse<RefreshData>> {
    const response = await client.post<ApiResponse<RefreshData>>(
      API.AUTH.REFRESH,
      undefined,
      SKIP_REFRESH_CONFIG,
    );

    return response.data;
  }

  /**
   * Current User
   */
  async me(): Promise<ApiResponse<MeApiResponse["data"]>> {
    const response = await client.get<ApiResponse<MeApiResponse["data"]>>(
      API.AUTH.ME,
    );

    return response.data;
  }

  /**
   * Logout
   */
  async logout(): Promise<ApiResponse<null>> {
    const response = await client.post<ApiResponse<null>>(
      API.AUTH.LOGOUT,
      undefined,
      SKIP_REFRESH_CONFIG,
    );

    return response.data;
  }
}

export const authApi = new AuthApi();

export default authApi;